import { Theme } from '@mui/material/styles'

import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3.5),
  },
  divider: {
    width: '100%',
    color: theme.palette.dividerV2.main,
    height: '1px',
  },
  selector: {
    marginTop: theme.spacing(-2),
    width: theme.spacing(48.12),
  },
  heading: {
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.15px',
    color: theme.palette.labraText.primary,
    fontFamily: theme.typography.fontFamily,
  },
  valueWrapper: {
    marginTop: theme.spacing(-1),
  },
  row: {
    padding: 0,
  },
  detail: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    padding: theme.spacing(2, 0, 0.5, 0),
  },
  rowRightItem: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    width: '100%',
    gap: theme.spacing(2),
    padding: theme.spacing(1.5, 1, 0, 0),
    height: theme.spacing(5),
  },
}))
